const decode = (data) => {
  return decodeURIComponent(escape(atob(reverse(data.slice(0, -7)))))
}
const decodeToken = (data) => {
  return escape(atob(reverse(data.slice(0, -10)))).slice(0, -5)
}
function reverse (s) {
  return s.split('').reverse().join('')
}
export default {
  decode,
  decodeToken
}



// WEBPACK FOOTER //
// ./src/services/decode.js